interface GameControlsProps {
  onRestart: () => void;
}

export default function GameControls({ onRestart }: GameControlsProps) {
  return (
    <div className="flex flex-col items-center gap-3 mt-8">
      <button 
        onClick={onRestart}
        className="btn bg-[#8f7a66] hover:bg-[#7c6957] border-none text-white px-10"
      >
        New Game
      </button>
      
      <div className="text-gray-600 mt-2 text-sm text-center">
        <p>Join the tiles, get to <strong>2048</strong>!</p>
        <p className="mt-1">Use <strong>arrow keys</strong> or <strong>swipe</strong> to move.</p>
      </div>
    </div>
  );
}